/**
 * Accordion Component
 * Handles accordion functionality with container-scoped behavior
 * Uses IIFE to avoid global scope pollution and redeclaration errors
 */

(function() {
    'use strict';
    
    // Check if already initialized to prevent multiple setups
    if (window.accordionInitialized) {
        return;
    }
    
    window.accordionInitialized = true;
    
    // Event handler for accordion clicks
    function handleAccordionClick(event) {
        var toggle = event.target.closest('.js-accordion-toggle');
        
        if (!toggle) {
            return;
        }
        
        event.preventDefault();
        event.stopPropagation();
        
        var accordionItem = toggle.closest('.js-accordion-item');
        var accordionContainer = toggle.closest('.accordion-container');
        
        if (!accordionItem || !accordionContainer) {
            console.log('Missing required elements');
            return;
        }
        
        var isCurrentlyActive = accordionItem.classList.contains('is-active');
        
        if (isCurrentlyActive) {
            // Close the clicked item
            accordionItem.classList.remove('is-active');
            console.log('Closed item');
        } else {
            // Close all other items in the same container
            var accordionItems = accordionContainer.querySelectorAll('.js-accordion-item');
            
            accordionItems.forEach(function(item) {
                if (item !== accordionItem && item.classList.contains('is-active')) {
                    item.classList.remove('is-active');
                    console.log('Closed other item in same container');
                }
            });
            
            // Open the clicked item
            accordionItem.classList.add('is-active');
            console.log('Opened item');
        }
    }
    
    // Initialize accordion when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            document.addEventListener('click', handleAccordionClick, false);
            console.log('Accordion initialized');
        });
    } else {
        // DOM is already ready
        document.addEventListener('click', handleAccordionClick, false);
        console.log('Accordion initialized');
    }
    
})();
